import { Row, Col, Spin } from "antd";
import StatCard from "components/statCard";
import {
  UserRound,
  Dumbbell,
} from "lucide-react";
import React from "react";

const ReviewsStats = ({ stats, isLoading }) => {

  return (
    <Spin spinning={isLoading}>
      <Row gutter={[16, 16]} style={{ marginBottom: 32 }}>
    

        <Col xs={24} sm={12} md={12} style={{ minWidth: 260 }}>
          <StatCard
            title={stats?.users ?? 0}
            subtitle="Alunos"
            icon={<UserRound size={18} color="#fff" />}
            iconColor="#2C2C2C"
          />
        </Col>

        <Col xs={24} sm={12} md={12} style={{ minWidth: 300 }}>
          <StatCard
            title={stats.reviews ?? 0}
            subtitle="Avaliações Efetuados"
            icon={<Dumbbell size={18} color="#fff" />}
            iconColor="#FDBA63"
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default ReviewsStats;
